import {
	logbookSelectors,
	productsSelectors,
	financialStatementsSelectors,
} from '~/store';
// ---- internal imports -----

function getSystemIncomeStatementParameters(state, quarter) {
	const revenue = parseInt(logbookSelectors.getTotalSalesFor(state, quarter));
	const openingInventory =
		parseInt(financialStatementsSelectors.getOpeningInventoryFor(state, quarter.num));
	const purchases = parseInt(logbookSelectors.getTotalPurchasesFor(state, quarter));
	const closingInventory = parseInt(productsSelectors.getInStockProductsValue(state));
	const lostInventory =
		financialStatementsSelectors.getLostInventoryForQuarter(state, quarter.num) ?? 0;
	const costOfGoodsSold = openingInventory + purchases - closingInventory - lostInventory;
	const grossProfit = revenue - costOfGoodsSold;
	const expenses = parseInt(logbookSelectors.getTotalExpensesFor(state, quarter));
	const netProfit = grossProfit - expenses;

	return {
		revenue, openingInventory, purchases,
		closingInventory, lostInventory, costOfGoodsSold,
		grossProfit, expenses, netProfit
	};
}


export {
	getSystemIncomeStatementParameters,
};
